import { PlusCircleOutlined } from "@ant-design/icons";
import { useContext, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  useAssignSCBOneDeviceToOrganization,
  useSCBOneDevices,
} from "../../api/api.scb-one";
import { Beacon } from "../../api/models";
import { DataRefreshContext } from "../../contexts/dataRefreshContext";
import { useSetting } from "../../util";
import { SelectBeaconsModal } from "./SelectBeaconsModal";

interface AssignSCBOneDevicesModalProps {
  organizationId: string;
}

export function AssignSCBOneDevicesModal({
  organizationId,
}: AssignSCBOneDevicesModalProps) {
  const { t } = useTranslation();
  const assignDevicesToOrganization = useAssignSCBOneDeviceToOrganization();
  const dataRefreshContext = useContext(DataRefreshContext);

  const onAssignDevicesToOrganization = async (serials: string[]) => {
    await assignDevicesToOrganization({ serials, organizationId });
    dataRefreshContext.refresh();
  };

  const devices = useSCBOneDevices(false);

  return (
    <SelectBeaconsModal
      title={t("scb-one:assign-device")}
      instruction={t("organization:assign-beacons-drawing-tooltip")}
      beacons={devices}
      assignedToOrganization={false}
      selectButtonText={(beaconIds) =>
        beaconIds.length > 1
          ? t("scb-one:assign-device-plural")
          : t("scb-one:assign-device")
      }
      selectButtonTitle={() => t("scb-one:assign-device-plural")}
      modalButtonIcon={<PlusCircleOutlined />}
      onBeaconsSelected={onAssignDevicesToOrganization}
    />
  );
}

const PagedState = (beacons: Beacon[] | undefined) => {
  const [currentPage, setCurrentPage] = useState(0);
  const [currentPageSize, setCurrentPageSize] = useSetting(
    "default-page-size",
    50
  );

  return {
    currentPage,
    currentPageSize: currentPageSize,
    goToPage: (p: any) => setCurrentPage(p),
    setPageSize: (pageSize: any) => setCurrentPageSize(pageSize),
    value: {
      items: beacons as unknown as Beacon[],
      totalCount: beacons?.length || 0,
    },
    loading: false,
    failed: false,
    lastLoadedAt: new Date(),
    refresh: () => {},
  };
};
